import { QSwitch } from '@qualio/ui-components';
import { useFormContext } from 'react-hook-form';
import { FfcChildProps, getFieldErrors } from '../shared';
import { FormEditorForm } from '../../../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import RequiredSwitch from './RequiredSwitch';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';
import FieldOptionLst from './FieldOptionLst';
import * as DisplayStrings from '../../../../../displayStrings';

const CheckboxFieldConfiguration = ({ fieldIndex }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper>
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <FieldOptionLst fieldIndex={fieldIndex} control={control} />
      <QSwitch isChecked={true} isDisabled={true}>
        {DisplayStrings.MultiSelect}
      </QSwitch>
      <RequiredSwitch control={control} fieldIndex={fieldIndex} />
    </FieldConfigurationWrapper>
  );
};

export default CheckboxFieldConfiguration;
